import React from "react";
import { Link } from "react-router-dom";
import { RiDeleteBinLine } from "react-icons/ri";
import { useDeleteHandler } from "../../../../hooks/useDeleteHandler";
import { DeleteBatch } from "../../../../services/adminApiService/batchManagementApi/BatchManagementApiService";

const BatchList = ({ batchList, loading, refreshList }) => {
    const { handleDelete } = useDeleteHandler();

    if (loading) {
        return (
            <div className="text-center p-5">
                <div className="spinner-border text-primary" />
            </div>
        );
    }


    const deleteHandler = (id) => {
        handleDelete({
            deleteApi: () => DeleteBatch(id),
            refreshListApi: () =>
                refreshList(), // Call the refreshList function passed as a prop
            successMsg: "Batch deleted successfully"
        });
    };

    const loginDetails = JSON.parse(localStorage.getItem("login_Details"));

    const canEdit = (batchUserLevel) => {
        // If loginDetails is not present, allow edit
        if (!loginDetails) {
            return true;
        }

        // If present, compare user levels
        return loginDetails?.user?.user_level === batchUserLevel;
    };


    return (
        <div className="card-body">
            <div className="w-100 table-responsive">
                <table className="display w-100 dataTable">
                    <thead>
                        <tr>
                            <th>Batch Name</th>
                            <th className="d-none d-md-table-cell">Sport</th>
                            <th className="d-none d-md-table-cell">Cluster</th>
                            <th className="d-none d-md-table-cell">Coach Name</th>
                            <th>Athletes</th>
                            <th>Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {batchList?.length > 0 ? (
                            batchList?.map((batch, index) => (
                                <tr key={batch?.batch_id || index}>
                                    <td>
                                        {batch?.batch_name}
                                        <div className="d-md-none text-muted" style={{ fontSize: "11px" }}>
                                            {[batch?.sport_name, batch?.cluster, batch?.supervisor_name?.trim()]
                                                .filter(Boolean).join(" · ")}
                                        </div>
                                    </td>
                                    <td className="d-none d-md-table-cell">{batch?.sport_name}</td>
                                    <td className="d-none d-md-table-cell">{batch?.cluster || "—"}</td>
                                    <td className="d-none d-md-table-cell">{batch?.supervisor_name?.trim() || "—"}</td>
                                    <td>
                                        {batch?.total_athletes ?? 0}
                                    </td>
                                    <td>
                                        <div className="d-flex">
                                            <Link to={`/batch-management/batches/viewBatch/${batch?.batch_id}`}>
                                                <div className="icon_wrapper cursor-pointer">
                                                    <i className="bi bi-eye"></i>
                                                </div>
                                            </Link>

                                            {/* <Link to={`/batch-management/batches/update/${batch?.batch_id}`}>
                                                <div className="icon_wrapper mx-2 cursor-pointer">
                                                    <i className="bi bi-pencil"></i>
                                                </div>
                                            </Link> */}
                                            {canEdit(batch?.user_level) ? (
                                                <Link to={`/batch-management/batches/update/${batch?.batch_id}`}>
                                                    <div className="icon_wrapper mx-2 cursor-pointer">
                                                        <i className="bi bi-pencil"></i>
                                                    </div>
                                                </Link>
                                            ) : (
                                                <div
                                                    className="icon_wrapper mx-2"
                                                    style={{
                                                        opacity: 0.2,
                                                        cursor: "not-allowed",
                                                        pointerEvents: "none",
                                                    }}
                                                >
                                                    <i className="bi bi-pencil"></i>
                                                </div>
                                            )}

                                            <div className="icon_wrapper mx-2 cursor-pointer" onClick={() => deleteHandler(batch?.batch_id)}>
                                                <RiDeleteBinLine className="text-danger" />
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" className="text-center py-4">
                                    No batches found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default BatchList;